import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import { Loading } from "./components/kit";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import OrderForm from "./pages/OrderForm";
import OrderDetail from "./pages/OrderDetail";
import Calendar from "./pages/Calendar";
import Stock from "./pages/Stock";
import StockItem from "./pages/StockItem";
import Customers from "./pages/Customers";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Finance from "./pages/Finance";
import Settings from "./pages/Settings";
import StockReport from "./pages/StockReport";

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

const ORDER = ["admin", "head_operator", "operator"];
const STOCK = ["admin", "gudang", "head_operator"];
const ADMIN = ["admin"];
const WAREHOUSE = ["admin", "gudang"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Guard><Layout /></Guard>}>
            <Route index element={<Dashboard />} />
            <Route path="order" element={<Guard roles={ORDER}><Orders /></Guard>} />
            <Route path="order/baru" element={<Guard roles={ADMIN}><OrderForm /></Guard>} />
            <Route path="kalender" element={<Guard roles={ORDER}><Calendar /></Guard>} />
            <Route path="order/:id" element={<Guard roles={ORDER}><OrderDetail /></Guard>} />
            <Route path="order/:id/edit" element={<Guard roles={ADMIN}><OrderForm /></Guard>} />
            <Route path="stok" element={<Guard roles={STOCK}><Stock /></Guard>} />
            <Route path="stok/laporan" element={<Guard roles={WAREHOUSE}><StockReport /></Guard>} />
            <Route path="stok/:id" element={<Guard roles={STOCK}><StockItem /></Guard>} />
            <Route path="pelanggan" element={<Guard roles={ADMIN}><Customers /></Guard>} />
            <Route path="pengguna" element={<Guard roles={ADMIN}><Users /></Guard>} />
            <Route path="pengaturan" element={<Guard roles={ADMIN}><Settings /></Guard>} />
            <Route path="laporan" element={<Guard roles={ADMIN}><Reports /></Guard>} />
            <Route path="keuangan" element={<Guard roles={ADMIN}><Finance /></Guard>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
